<template>
  <v-col :id="id" cols="12" sm="6">
    <v-div border-primary-bottom-thick mb-4>
      <h2 class="title font-weight-bold">{{ title }}</h2>
    </v-div>
    <ArticleSummary
      v-if="selectedArticle"
      :item="selectedArticle"
      show-metric="MAIN_ITEM_DOWNLOAD_COUNT"
      :show-content-type="showContentType"
    />
  </v-col>
</template>

<script>
import {
  displayIsMobile,
  displayIsTablet,
} from "~/components/utilities/displayBreakpoints";
import ArticleSummary from "~/components/articles/ArticleSummary";

export default {
  name: "ArticleMostPopular",
  components: {
    ArticleSummary,
  },
  props: {
    id: { type: String, required: true },
    offsetValue: { type: String, default: "0" },
    selectedArticle: { type: Object, required: true },
    showContentType: { type: Boolean, default: false },
    title: { type: String, required: true },
  },
  computed: {
    displayIsMobile,
    displayIsTablet,
  },
};
</script>
